import React, { useEffect, useState } from 'react';
import { getClientCode, getClientId } from './selectors/client';

import CSSSwitcher from './components/CssSwitcher';
import Footer from './containers/Footer';
import GoogleTagManager from './components/Tracking/GoogleTagManager';
import Header from './containers/Header';
import LoadingOverlay from './components/LoadingOverlay';
import PromptOverlay from './containers/PromptOverlay';
import PropTypes from 'prop-types';
import Routes from './Routes';
import ToastOverlay from './containers/ToastOverlay';
import { clientOperations } from './store/client';
import { compose } from 'redux';
import { connect } from 'react-redux';
import constants from './constants';
import { setBrowserHeightUnit } from './lib/browser';
import styles from './App.styles';
import { withStyles } from '@kaboodle-solutions/design-system';

const App = ({ classes, clientId, code, loadClientId, loadClientConfig }) => {
  useEffect(() => {
    if (!clientId) {
      loadClientId();
    }
    if (clientId) {
      loadClientConfig();
    }
  }, [clientId]);

  useEffect(() => {
    setBrowserHeightUnit();
    window.addEventListener('resize', setBrowserHeightUnit);
    return function cleanup() {
      window.removeEventListener('resize', setBrowserHeightUnit);
    };
  });

  // Initialize weglot translation based on domain
  const [weglotInit, setWeglotInit] = useState(false);
  useEffect(() => {
    const translate =
      location.hostname.includes('primavera') ||
      location.hostname.includes('localhost');

    if (translate && !weglotInit && window.Weglot) {
      setWeglotInit(true);
      window.Weglot.initialize({
        api_key: constants.WEGLOT_API_KEY,
      });
    }
  }, [window.Weglot]);

  if (!code) {
    return <LoadingOverlay />;
  }

  return (
    <>
      <div className={classes.app}>
        <div className={classes.wrap}>
          <Header />
          {clientId && <Routes />}
          <ToastOverlay />
          <PromptOverlay />
        </div>
        <div className={classes.footerWrap}>
          <Footer />
        </div>
      </div>
      <CSSSwitcher />
      <GoogleTagManager />
    </>
  );
};

App.propTypes = {
  classes: PropTypes.object,
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  code: PropTypes.string,
  loadClientConfig: PropTypes.func,
  loadClientId: PropTypes.func,
};

App.defaultProps = {
  classes: {},
  clientId: null,
  code: '',
  loadClientConfig: null,
  loadClientId: null,
};

const mapStateToProps = state => ({
  clientId: getClientId(state),
  code: getClientCode(state),
});

const mapDispatchToProps = {
  loadClientConfig: clientOperations.getClientConfig,
  loadClientId: clientOperations.getClientId,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(App);
